///<reference path="../../components/short-cuts/index.d.ts"/>

module Meevo.Plugins.StockLevels {
    import ShortCutsStateManagerController = Meevo.Components.ShortCuts.ShortCutsStateManagerController;
    import ShortCutGroup = Meevo.Components.ShortCuts.ShortCutGroup;
    import IShortCutGroup = Meevo.Components.ShortCuts.IShortCutGroup;

    class StockLevelsController extends ShortCutsStateManagerController {

        closeContext: Function;
        context: StockLevelsContext;
        shortCutGroup: IShortCutGroup | { [key: number]: IShortCutGroup };

        noun = Meevo.Model.NounEnum.StockLevelPage;

        get mode(): Meevo.Model.MaintenanceFormState {
            return this.context ? this.context.mode : Meevo.Model.MaintenanceFormState.Readonly;
        }

        static $inject = [
            "meevo.AppSettings", "meevo.components.common.DataService",
            "meevo.components.modal.ModalService", "$rootScope", "$state",
            "meevo.components.tracking.TrackingService",
            "$scope", "meevo.components.short-cuts.ShortCutsService",
            "meevo.components.busy.BusyService",
            "meevo.components.common.IdentityService",
            "meevo.components.common.SecurityService",
            "$translate", "$q", "$filter"
        ];

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected $rootScope: angular.IRootScopeService,
            protected $state: any,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected $scope: ng.IScope,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected $translate: ng.translate.ITranslateService,
            protected $q: ng.IQService,
            protected $filter: angular.IFilterService
        ) {
            super($scope, $state, shortCutsService);

            this.shortCutGroup = {
              [Meevo.Model.MaintenanceFormState.Readonly]: new ShortCutGroup([{
                  shortCutName: 'DATA_MAINTENANCE_EDIT',
                  callback: this.shortCutsService.contextMethodsWrapper<StockLevelsContext, StockLevelsController>(this, 'edit')
              }])  ,
                [Meevo.Model.MaintenanceFormState.Editing]: new ShortCutGroup([{
                    shortCutName: 'DATA_MAINTENANCE_SAVE',
                    callback: this.shortCutsService.contextMethodsWrapper<StockLevelsContext, StockLevelsController>(this, 'save')
                }, {
                    shortCutName: 'DATA_MAINTENANCE_CANCEL',
                    callback: this.shortCutsService.contextMethodsWrapper<StockLevelsContext, StockLevelsController>(this, 'cancel')
                }])
            };

            let vm = this;
            vm.context = new StockLevelsContext(appSettings, dataService, modalService, trackingService, busyService, identityService, securityService, $translate, $rootScope, $scope, $q, $filter);


            vm.closeContext = (): void => {
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state.current, null);
            }
        }
    }

    angular.module("meevo.plugins.stockLevels")
        .controller("meevo.plugins.stockLevels.StockLevelsController", StockLevelsController);
}